/* eslint-disable @typescript-eslint/no-explicit-any */
import { IProductDTO } from '../../../legacy/shared-types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { productApi } from 'api/product/productsApi';

export const useProductById = (id?: string): UseQueryResult<IProductDTO> =>
  useQuery(['products-list', id], () => (id ? productApi.getProductById(id) : {}), {
    enabled: !!id,
  });
